import React, { useState, useEffect, useRef } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { Helmet } from "react-helmet";
import format from 'date-fns/format';
import { DateRange } from 'react-date-range';



//final home page import section
import backgroundImage from "../images/BKB-Elements/bg.gif";
import backgroundImg from "../images/BKB-Elements/bg_new.png";
import saleAstraImg from "../images/Astra/Sale/S0.png";
import retailerAstraImg from "../images/Astra/Retailer/R0.png";
import serviceAstraImg from "../images/Astra/Service/SE0.png";
import Rank from "../images/BKB-Elements/Rank.png";
import BKBLeaderboard from './BKBLeaderboard';
import retailer_bg from "../images/BKB-Elements/retailer_bg.gif";
import sale_bg from "../images/BKB-Elements/sale_bg.gif";
import service_bg from "../images/BKB-Elements/service_bg.gif";
import MyRank from './MyRank';

import myRankBGImage from "../images/BKB-Elements/Rank_top_nav_bar_button.png";
import SemiProgressBar from './SemiProgressBar';
import TableData from './TableData';
import ImpactPlayerLeaderboard from './ImpactPlayerLeaderboard';

function HomePage() {
    const [cookies] = useCookies(['user'])
    const user_id = cookies.user_id;
    const token = cookies.token;
    const textData = '( Recharge, DMT,IRCTC,MATM, Bill payments, Aeps, Cashdrop, PG, Dhanak and flight will be considered )';
    let history = useHistory();
    let textInput = React.createRef();
    const row = [];
    const [loader, setLoader] = useState("true");
    // const[retailerProgress, setRetailerProgress] = useState({ background: 'conic-gradient(rgb(0, 255, 242) 0deg, transparent 0deg)'});
    // const[saleProgress, setSaleProgress] = useState({ background: 'conic-gradient(rgb(0, 255, 242) 0deg, transparent 0deg)'});
    // const[serviceProgress, setServiceProgress] = useState({ background: 'conic-gradient(rgb(0, 255, 242) 0deg, transparent 0deg)'});
    const [congratulationPopupHeaderContent, setCongratulationPopupHeaderContent] = useState(null);
    const [pendingServices, setPendingServices] = useState(null);
    const [sortedDateRangeBreakupHtmlData, setSortedDateRangeBreakupHtmlData] = useState(null);
    const [sortedDateBreakupHtmlData, setSortedDateBreakupHtmlData] = useState(null);
    const [srcUrl, setSrcUrl] = useState({
        "image_one": null,
        "image_two": null
    });

    const [targetsData, setTargetsData] = useState([]);
    let [carausolBackgroundImgStyle, setCarausolBackgroundImgStyle] = useState();
    const [warData, setWarData] = useState(null);
    const [warStatus, setWarStatus] = useState(null);
    const [secondSlide, setSecondSlide] = useState(null);
    const [astraActive, setAstraActive] = useState("active");
    const [showing, setShowing] = useState("");

    const [borActive, setBorActive] = useState("");
    const [slideMarker, setSlidemarker] = useState("");
    const timerComponents2 = [];
    const slide1 = useRef(null);
    const slide2 = useRef(null);

    const [congratsFooterContent, setCongratsFooterContent] = useState('');
    useEffect(() => {
        callBORApi();
        getPointsBreakup();
        // getDistData();
        // getAllLiveWar();
        const interval = setInterval(() => {
            let timeLt = timeLeftToIW();
            // console.log(timeLt);
            setTimeLeft(timeLt);
        }, 1000);
        return () => { clearInterval(interval) };
    }, []);

    const timeLeftToIW = () => {
        let wet = localStorage.getItem("warStartTime");
        if (wet === "" || wet === undefined) {
            return;
        }
        const difference = +new Date(wet) - +new Date();
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                // days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60))),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        } else {
            return { 'no': 1 };
        }
        return timeLeft;
    };
    const [timeLeft, setTimeLeft] = useState(timeLeftToIW());

    let i = 10000;
    Object.keys(timeLeft).forEach((interval) => {
        if (interval == 'no') {
            timerComponents2.push("");
            return;
        }
        if (!timeLeft[interval] && timeLeft[interval] != 0) {
            return;
        }
        let a = timeLeft[interval];
        if (interval == 'days') {
            timerComponents2.push(
                <a key={i}>
                    {a}{" Days : "}
                </a>
            );
        }
        if (interval == 'hours') {
            timerComponents2.push(
                <a key={i}>
                    {a}{" hours : "}
                </a>
            );
        }
        if (interval == 'minutes') {
            timerComponents2.push(
                <a key={i}>
                    {a}{" mins : "}
                </a>
            );
        }
        if (interval == 'seconds') {
            timerComponents2.push(
                <a key={i}>
                    {a}{" secs"}
                </a>
            );
        }
        i++;
    });


    // pointsBreakup.targets_data.retailer.percentage
    const [pointsBreakup, setPointsBreakup] = useState({ "status": "failuer", "dmt": 0, "micro_atm": 0, "aeps": 0, "recharge": 0, "other": 0, "month_total": 0, "targets_data": { "retailer": {}, "sale": {}, "service": {} } });
    const [dateBreakup, setDateBreakup] = useState({ "dmt": 0, "micro_atm": 0, "aeps": 0, "recharge": 0, "other": 0, "bonus": 0 });
    const [dateRangeBreakup, setDateRangeBreakup] = useState({ "dmt": 0, "micro_atm": 0, "aeps": 0, "recharge": 0, "other": 0, "bonus": 0 });
    const [dailyPts, setDailyPts] = useState(0);
    const [milestone, setMilestone] = useState({ "a": "0%", "b": "0%", "c": "0%", "d": "0%", "e": "0%", "f": "0%", "g": "0%", "h": "0%", "i": "0%", "j": "0%", "l1": require("./../images/1l-inact.svg").default, "l3": require("./../images/3l-inact.svg").default, "l10": require("./../images/10l-inact.svg").default, "l25": require("./../images/25l-inact.svg").default });
    const [error1, setError] = useState(false);
    const [desc, setDesc] = useState("");
    const inputRef = React.useRef(null);
    const [open, setOpen] = useState(false);
    const [range, setRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ]);
    const [range1, setRange1] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ]);
    const refOne = useRef(null);
    const [miDate, setMiDate] = useState(new Date(1970, 1, 1));
    const [maDate, setMaDate] = useState(new Date());

    const [saleTargetDisplay, setSaleTargetDisplay] = useState("");
    const [serviceTargetDisplay, setServiceTargetDisplay] = useState("");
    const [serviceTarget, setServiceTarget] = useState("");
    const [retailerTargetDisplay, setRetailerTargetDisplay] = useState(<div key="ret1"></div>);

    // useEffect(() => {
    //     // event listeners
    //     document.addEventListener("keydown", hideOnEscape, true)
    //     // document.addEventListener("click", hideOnClickOutside, true)
    //     setTimeout(() => {
    //         OpenCongratulationModal();
    //     }, 1000);
    // }, []);
    const hideOnEscape = (e) => {
        // console.log(e.key)
        if (e.key === "Escape") {
            localStorage.setItem("clickCnt", 0);
            setOpen(false);
            if ((localStorage.getItem("pbsd") !== localStorage.getItem("pbs") || localStorage.getItem("pbed") !== localStorage.getItem("pbe")) && (localStorage.getItem("pbs") != '' || localStorage.getItem("pbe") != '')) {
                console.log('-----=====here=====----');
                newDateRange();
            }
        }
    };
    const hideOnClickOutside = (e) => {
        // console.log(refOne.current)
        // console.log(!refOne.current.contains(e.target));
        if (refOne.current && !refOne.current.contains(e.target)) {
            localStorage.setItem("clickCnt", 0);
            setOpen(false);
            if ((localStorage.getItem("pbsd") !== localStorage.getItem("pbs") || localStorage.getItem("pbed") !== localStorage.getItem("pbe")) && (localStorage.getItem("pbs") != '' || localStorage.getItem("pbe") != '')) {
                console.log('-----=====here=====----');
                newDateRange();
            }
        }
    };
    const getPointsBreakup = async () => {
        localStorage.setItem("pbsd", "");
        localStorage.setItem("pbed", "");
        var tmp = new Date();
        localStorage.setItem("pbs", format(tmp, "yyyy-MM-dd"));
        localStorage.setItem("pbe", format(tmp, "yyyy-MM-dd"));
        localStorage.setItem("d", "");
        newDateRange();
    };

    async function callBORApi() {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ dist_user_id: user_id }),

        };
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-bor-data', requestOptions);
        const res = await response.json();
        if (res.status !== "success" || res.data.k_id == "NA") {
            // setError(true);
            console.log('error1');
        }
        setWarData(res.data);
        setWarStatus(res.data.show_5x);
        localStorage.setItem('war_status', res.data.show_5x);
        let bor = "";
        const data = res.data;
        if (res.data.show_5x) {
            localStorage.setItem('slide', '2');
            setAstraActive("");
            setBorActive("active");
            let trend = "at a standstill"
            if (res.data.name == res.data.kd1_name) {
                if (res.data.kd1_points > res.data.kd2_points) {
                    trend = "leading"
                } else if (res.data.kd1_points < res.data.kd2_points) {
                    trend = "trailing"
                }
            } else {
                if (res.data.kd1_points > res.data.kd2_points) {
                    trend = "trailing"
                } else if (res.data.kd1_points < res.data.kd2_points) {
                    trend = "leading"
                }
            }
            setSlidemarker("0");
            setSecondSlide(
                <Link to={{
                    pathname: "/war-score",
                    state: [data, '']
                }} key="secsli1" className="carousel-item bkb">
                    <div
                        className="align-items-center justify-content-center slide_2"
                        style={{
                            backgroundImage: `url(${require("../images/Impact_player_screen/Onboarding_screen/live_war.gif")
                                .default
                                })`,
                            backgroundSize: "100% 100%",
                        }}
                    >
                        <div className="battle_of_region text-white text-center">BATTLE OF REGIONS </div>
                        <div className="battle_no text-white text-center">BATTLE NO. {res.data.battle_no} </div>
                        <div className='teams'>
                            <div className="team_1 text-white text-center">
                                <span>{res.data.kd1_name}</span>
                            </div>
                            <div style={{ width: '20%' }}></div>
                            <div className="team_2 text-white text-center"><span>{res.data.kd2_name}</span> </div>
                        </div>
                        <div className="leading_text text-white text-center">Your Region is {trend}. </div>
                        <div className="live_text text-white text-center">
                            <img src={require("./../images/Impact_player_screen/live.png").default} alt="alt" style={{ height: '1.5em' }} />
                        </div>
                    </div>
                </Link>
            );
        } else if (data.start_date !== "") {
            localStorage.setItem('slide', '2');
            setAstraActive("");
            setBorActive("active");
            setSlidemarker("1");
            localStorage.setItem("warStartTime", data.start_date);
        } else {
            localStorage.setItem('slide', '1');
            setSecondSlide(
                <div key="secsli2" className="carousel-item bkb">
                    <div
                        className="align-items-center justify-content-center slide_4"
                        style={{
                            backgroundImage: `url(${require("../images/Impact_player_screen/Onboarding_screen/normal_day.png")
                                .default
                                })`,
                            backgroundSize: "100% 100%",
                        }}
                    >
                        <div className="slider_point_1 text-white">
                            <span>{data.wars_won}</span>
                        </div>
                        <div className="slider_point_2 text-white">
                            <span>{data.rank}</span>
                        </div>
                        <div className="slider_bottom_link text-white text-center">
                            <Link to={{
                                pathname: "/region-home"
                            }} style={{ color: "white" }}>View Today's War</Link>
                        </div>
                    </div>
                </div>
            );
        }
    }

    const handleAstraClick = (astra) => {
        console.log(astra, 'astra')
        history.push({
            pathname: '/distributor-jarvis',
            state: {
                astra,
                milestone: '',
                date: format(new Date(), "yyyy-MM-dd"),
                section: 'dist_bkb_astra'
            }
        })
    }

    const handleMildstoneClick = (milestone) => {
        history.push({
            pathname: '/distributor-jarvis',
            state: {
                astra: '',
                milestone: milestone,
                date: format(new Date(), "yyyy-MM-dd"),
                section: 'dist_bkb_milestones'
            }
        })
    }

    async function newDateRange() {
        console.log("---------------------");
        // console.log(format(range[0].startDate, "yyyy-MM-dd"));
        var sDate = localStorage.getItem("pbs");
        var eDate = localStorage.getItem("pbe");
        localStorage.setItem("clickCnt", 0);
        let type = "";
        if (localStorage.getItem("d") === "1") {
            type = "1";
        } else if (localStorage.getItem("d") === "0") {
            type = "0";
        }
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ dist_user_id: user_id, start_date: sDate, end_date: eDate, new_ui: "true" }),

        };
        //sleep function
        // function timeout(delay) {
        // 	return new Promise( res => setTimeout(res, delay) );
        // }
        // await timeout(100000);
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-all-distributor-home-data', requestOptions);
        const data = await response.json();

        if (data.status !== "success") {
            // setLoader('error');
            // alert(data.desc)
            // setError(true);
            setDesc(data.desc);
            // console.log(inputRef);
            inputRef.current.click();
            // function timeout(delay) {
            //     	return new Promise( res => setTimeout(res, delay) );
            //     }
            //     await timeout(100000);
            if (type === "1") {
                setRange1([
                    {
                        startDate: new Date(localStorage.getItem("pbsd")),
                        endDate: new Date(localStorage.getItem("pbed")),
                        key: 'selection'
                    }
                ]);
            } else {
                setRange([
                    {
                        startDate: new Date(localStorage.getItem("pbsd")),
                        endDate: new Date(localStorage.getItem("pbed")),
                        key: 'selection'
                    }
                ]);
            }
            localStorage.setItem("pbs", localStorage.getItem("pbsd"));
            localStorage.setItem("pbe", localStorage.getItem("pbed"));
            // console.log(error1);
        } else {
            if (data.showing === "live") {
                console.log("--------------------------------today------");
                setShowing(<img alt="" src={require("./../images/live.png").default} className="img-fluid backIcon" />)
            } else {
                console.log("--------------not------------------today------");

                setShowing(<div><img alt="" src={require("./../images/datebox.png").default} className="img-fluid backIcon" /><div class="centered">{data.showing}</div></div>)
            }
            setTargetsData(data.targets_data);
            localStorage.setItem("pbsd", sDate);
            localStorage.setItem("pbed", eDate);
            let pts = data.total_points.replaceAll(',', '');
            console.log(pts);
            if (pts <= 100000) {
                let perc = pts * 100 / 100000;
                setMilestone({ "a": perc + "%", "b": "0%", "c": "0%", "d": "0%", "e": "0%", "f": "0%", "g": "0%", "h": "0%", "i": "0%", "j": "0%", "l1": require("./../images/BKB-Elements/Milestone 1L.svg").default, "l3": require("./../images/BKB-Elements/Milestone 5L.svg").default, "l10": require("./../images/BKB-Elements/Milestone 10L.svg").default, "l25": require("./../images/BKB-Elements/Milestone 25L.svg").default });
            } else if (pts > 100000 && pts <= 500000) {
                let perc = (pts - 100000) * 100 / 400000;
                setMilestone({ "a": "100%", "b": "0%", "c": perc + "%", "d": "0%", "e": "0%", "f": "0%", "g": "0%", "h": "0%", "i": "0%", "j": "0%", "l1": require("./../images/BKB-Elements/Milestone 1L.svg").default, "l3": require("./../images/BKB-Elements/Milestone 5L.svg").default, "l10": require("./../images/BKB-Elements/Milestone 10L.svg").default, "l25": require("./../images/BKB-Elements/Milestone 25L.svg").default });
            } else if (pts > 500000 && pts <= 1000000) {
                let perc = (pts - 500000) * 100 / 500000;
                setMilestone({ "a": "100%", "b": "0%", "c": "100%", "d": "0%", "e": perc + "%", "f": "0%", "g": "0%", "h": "0%", "i": "0%", "j": "0%", "l1": require("./../images/BKB-Elements/Milestone 1L.svg").default, "l3": require("./../images/BKB-Elements/Milestone 5L.svg").default, "l10": require("./../images/BKB-Elements/Milestone 10L.svg").default, "l25": require("./../images/BKB-Elements/Milestone 25L.svg").default });
            } else if (pts > 1000000 && pts <= 2500000) {
                let perc = (pts - 1000000) * 100 / 1500000;
                setMilestone({ "a": "100%", "b": "0%", "c": "100%", "d": "0%", "e": "100%", "f": "0%", "g": perc + "%", "h": "0%", "i": "0%", "j": "0%", "l1": require("./../images/BKB-Elements/Milestone 1L.svg").default, "l3": require("./../images/BKB-Elements/Milestone 5L.svg").default, "l10": require("./../images/10l-act.svg").default, "l25": require("./../images/BKB-Elements/Milestone 25L.svg").default });
            } else {
                let perc = (pts - 2500000) * 100 / 2500000;
                if (perc > 85) {
                    perc = 85;
                }
                if (data.rank === "1") {
                    perc = 100;
                } else if (data.rank === "2") {
                    perc = 95;
                } else if (data.rank === "3") {
                    perc = 90;
                }

                setMilestone({ "a": "100%", "b": "0%", "c": "100%", "d": "0%", "e": "100%", "f": "0%", "g": "100%", "h": "0%", "i": perc + "%", "j": "0%", "l1": require("./../images/1l-act.svg").default, "l3": require("./../images/3l-act.svg").default, "l10": require("./../images/10l-act.svg").default, "l25": require("./../images/25l-act.svg").default });
            }
            let temp = data;
            let dateBreakupTempData = { "dmt": 0, "micro_atm": 0, "aeps": 0, "recharge": 0, "membership": 0, "bonus": 0 };
            let dateRangeBreakupTempData = { "dmt": 0, "micro_atm": 0, "aeps": 0, "recharge": 0, "membership": 0, "bonus": 0 };
            if (type === "") {
                setDailyPts(data.month_total);
                setDateRangeBreakup(temp);
                setDateBreakup(temp);
                dateBreakupTempData = temp;
                dateRangeBreakupTempData = temp;
            } else if (type === "1") {
                setDateBreakup(temp);
                dateBreakupTempData = temp;
            } else if (type === "0") {
                setDateRangeBreakup(temp);
                dateRangeBreakupTempData = temp;
            }

            setPointsBreakup(temp);
            localStorage.setItem("user_profile", data?.dist_profile_pic || "")
            localStorage.setItem("ami", data.typeCode);
            // if(data.type !== 0){
            //     setLoader('false');
            //     function timeout(delay) {
            //         return new Promise( res => setTimeout(res, delay) );
            //     }
            //     await timeout(2700);
            //     OpenCongratulationModal();
            // }
            let retImg = 0;
            let saleImg = 0;
            let serviceImg = 0;
            var serviceG = "a.png";
            var retailerG = "a.png";
            var saleG = "a.png";

            if (data.targets_data.retailer.completed_status === false) {
                retImg = data.targets_data.retailer.percentage + ".png";
                retailerG = "Green.gif";
            } else {
                retailerG = "greenline.png";
                retImg = data.targets_data.retailer.percentage + ".gif";
            }

            let serTra = data.targets_data.service.total_taget;
            if (data.targets_data.service.total_taget < 5) {
                serTra = parseInt(data.targets_data.service.total_taget) + 1;
            }
            setServiceTarget(serTra);
            if (data.targets_data.service.completed_status === false) {
                serviceImg = data.targets_data.service.percentage + ".png";
                serviceG = "Blue.gif";
            } else {
                serviceG = "blueline.png";
                serviceImg = data.targets_data.service.percentage + ".gif";
            }
            if (data.targets_data.sale.completed_status === false) {
                saleImg = data.targets_data.sale.percentage + ".png";
                saleG = "Brown.gif";
            } else {
                saleG = "brownline.png";
                saleImg = data.targets_data.sale.percentage + ".gif";
            }

            setServiceTargetDisplay(
                <div key="serTargetDiv" className='serTargetDiv'
                    onClick={() => handleAstraClick('Service')}
                    style={{
                        cursor: "pointer",
                        position: "relative"
                    }}
                >
                    <div>Target: {serTra} service</div>
                    <div>Current: {data.targets_data.service.completed_target} service</div>
                    <div className="service-click"></div>
                </div>
            );
            setRetailerTargetDisplay(
                <div key="retTargetDiv" className='retTargetDiv'
                    onClick={() => handleAstraClick('Retailer')}
                    style={{
                        cursor: "pointer",
                        position: "relative"
                    }}
                >
                    <div>Target: {data.targets_data.retailer.total_target} retailer</div>
                    <div>Current: {data.targets_data.retailer.completed_target} retailer</div>
                    <div className="retailer-click"></div>
                </div>
            );
            setSaleTargetDisplay(
                <div key="saleTargetDiv" className='saleTargetDiv'>
                    <div
                        onClick={() => handleAstraClick('Sale')}
                        style={{
                            cursor: "pointer",
                            position: "relative",
                            textAlign: "center"
                        }}
                    >
                        <span>Target : ₹</span><span className='target-points'>{data.targets_data.sale.total_taget}</span>
                    </div>
                    <div
                        onClick={() => handleAstraClick('Sale')}
                        style={{
                            cursor: "pointer",
                            textAlign: "center"
                        }}
                    >
                        <span>Current : ₹</span><span className='current-points'>{data.targets_data.sale.completed_target}</span>
                    </div>
                    <div
                        className="sale-click"
                        onClick={() => handleAstraClick('Sale')}
                        style={{
                            cursor: "pointer",
                            display: "hidden"
                        }}
                    ></div>
                </div>
            );
            // url(${require("../images/Astra/"+sale+".gif").default} , url(${require("../images/Astra/"+service+"").default} , url(${require("../images/Astra/"+retailer+"").default} ,  
            /***
            if(data.targets_data.all_target_completed_status === true){

                setCongratulationPopupHeaderContent(
                    <div key="11111setCongratulationPopupHeaderContent1111">
                        <p className='text-center' style={{color : "#eba434"}}>
                                YOU HAVE EARNED 100% BONUS POINT
                            </p>
                    </div>
                );
                setBackgroundImgStyle(
                    {
                        backgroundImage: `url(${require("../images/animation/6.gif").default}) `,
                        // backgroundSize: "50% 50%, 50% 50%,50% 50%,100% 100%",
                        backgroundRepeat: "no-repeat"
                    }
                );  
                OpenCongratulationModal();
            } else {
                setBackgroundImgStyle(
                    {
                        // backgroundImage: `url(${require("../images/Astra/"+serviceG+"").default}) ,url(${require("../images/Astra/"+retailerG+"").default}) ,url(${require("../images/Astra/"+saleG+"").default}) ,  url(${require("../images/Astra/Retailer/R"+retImg+"").default}) , url(${require("../images/Astra/Sale/S"+saleImg+"").default}), url(${require("../images/Astra/Service/SE"+serviceImg+"").default}), url(${backgroundImg})  `,
                        backgroundImage: `url(${backgroundImg})  `,
                        // backgroundSize: "50% 50%, 50% 50%,50% 50%,100% 100%",
                        backgroundRepeat: "no-repeat,no-repeat,no-repeat repeat-y"
                    }
                );
            }
             */
            setBackgroundImgStyle(
                {
                    backgroundImage: `url(${backgroundImg})  `,
                    backgroundRepeat: "no-repeat"
                }
            );
            if (data.targets_data.all_target_completed_status === true) {
                setCongratulationPopupHeaderContent(
                    <div key="11111setCongratulationPopupHeaderContent1111">
                        <p className='text-center' style={{ color: "#eba434" }}>
                            YOU HAVE EARNED 100% BONUS POINT
                        </p>
                    </div>
                );
                setCarausolBackgroundImgStyle(
                    {
                        backgroundImage: `url(${require("../images/BKB-Elements/FullStone.png").default}) `,
                        // backgroundSize: "50% 50%, 50% 50%,50% 50%,100% 100%",
                        backgroundRepeat: "no-repeat",
                        marginTop: "-8vh",
                        backgroundSize: "100% 100%",
                        backgroundPosition: "center"
                    }
                );
                OpenCongratulationModal();
                setSaleTargetDisplay("");
                setServiceTargetDisplay("");
                setRetailerTargetDisplay("");
            } else {
                setCarausolBackgroundImgStyle({
                    backgroundImage: `url(${require("../images/Astra/" + serviceG + "").default
                        }) ,url(${require("../images/Astra/" + retailerG + "").default}) ,url(${require("../images/Astra/" + saleG + "").default
                        }) ,  url(${require("../images/Astra/Retailer/R" + retImg + "").default
                        }) , url(${require("../images/Astra/Sale/S" + saleImg + "").default
                        }), url(${require("../images/Astra/Service/SE" + serviceImg + "").default
                        })`,
                    // backgroundSize: "50% 50%, 50% 50%,50% 50%,100% 100%",
                    backgroundRepeat:
                        "no-repeat,no-repeat,no-repeat,no-repeat,no-repeat,no-repeat",
                    marginTop: "-8vh",
                    backgroundSize: "100% 100%",
                    backgroundPosition: "center"
                });
            }
            setSortedDateRangeBreakupHtmlData(getDateBreakupHtml(getSortedServicesData(dateRangeBreakupTempData)));
            setSortedDateBreakupHtmlData(getDateBreakupHtml(getSortedServicesData(dateBreakupTempData)));

            setLoader('false');
            /**
            if(data.type !== 0){
                setBackgroundImageStyle({
                    backgroundImage: `url(${require("../images/animation/"+data.type+".gif").default})`,
                });
                setLoader('false');
                function timeout(delay) {
                    return new Promise( res => setTimeout(res, delay) );
                }
                await timeout(2700);
                OpenCongratulationModal();
            }

            if (data.typeCode === "111") {
                setTimeout(() => {
                    setBackgroundImageStyle({
                        backgroundImage: `url(${require("../images/background/"+data.typeCode+"_background.gif").default})`,
                    });
                }, 3400);
            } else {
                setTimeout(() => {
                    setBackgroundImageStyle({
                        backgroundImage: `url(${require("../images/background/"+data.typeCode+"_background.gif").default})`,
                    });
                });
            }
            setLoader('false');

            setSortedDateRangeBreakupHtmlData(getDateBreakupHtml(getSortedServicesData(dateRangeBreakupTempData)));
            setSortedDateBreakupHtmlData(getDateBreakupHtml(getSortedServicesData(dateBreakupTempData)));

            let retclasss = 'retailer_target_'+data.target_status;
            let saleclasss = 'sale_target_'+data.target_status;
            let serviceclasss = 'service_target_'+data.target_status;
            let retHtml = '';
            if(data.targets_data.retailer.completed_status === false){
                retHtml = <div className={retclasss} style={{ background: 'conic-gradient(#2AF19D '+data.target_progress_bar_data.retailer_degree+'deg, transparent 0deg)'}} onClick={OpenRetailerAstraModal}>
                    <img className='width-100' src={require("./../images/BKB-Elements/retailer_bg.gif").default} alt="alt"/>
                </div>;
            }

            let saleHtml = '';
            if(data.targets_data.sale.completed_status === false){
                saleHtml = <div className={saleclasss} style={{ background: 'conic-gradient(#2AF19D '+data.target_progress_bar_data.sale_degree+'deg, transparent 0deg)'}} onClick={OpenSaleAstraModal}>
                    <img  className='width-100' src={require("./../images/BKB-Elements/sale_bg.gif").default} alt="alt"/>
                </div>;
            }

            let serviceHtml = '';
            if(data.targets_data.service.completed_status === false){
                serviceHtml = <div className={serviceclasss} style={{ background: 'conic-gradient(#2AF19D '+data.target_progress_bar_data.service_degree+'deg, transparent 0deg)'}} onClick={OpenServiceAstraModal}>
                    <img  className='width-100' src={require("./../images/BKB-Elements/service_bg.gif").default} alt="alt"/>
                </div>
            }

            

            */
            //pending services section start
            let pendingServicesHtml = '';
            if (data.pendigServicesNames.length > 0) {
                let picons = [];
                data.pendigServicesNames.forEach((el) => {
                    picons.push(<img className='pendingServicesImage' src={require("./../images/icons-transaction-pending/" + el + ".png").default} alt="pendingServiceImage" />)
                });
                pendingServicesHtml = <div className='transactions_pending' key="kjhaakc">
                    <div className='pending_transaction'>
                        <span className='text-white' style={{ fontSize: "12px" }}>Transactions Pending</span>
                        <img style={{ marginLeft: "5px", height: "16px" }} src={require("./../images/icons-transaction-pending/trans_pending.png").default} alt="pendingServiceImage" />
                    </div>
                    <div className='pending_transaction_icon'>
                        {picons}
                    </div>
                </div>
            }
            setPendingServices(pendingServicesHtml);
            //pending services section end
        }
        if (localStorage.getItem('slide') === "1") {
            slide1.current.click();
        } else {
            slide2.current.click();
        }
    }

    async function setRange2(item) {
        setRange(item);
        localStorage.setItem("pbs", format(item[0].startDate, "yyyy-MM-dd"));
        localStorage.setItem("pbe", format(item[0].endDate, "yyyy-MM-dd"));
        let cnt = localStorage.getItem("clickCnt");
        cnt++;
        localStorage.setItem("clickCnt", cnt);
        if (cnt == 2) {
            setOpen(false);
            localStorage.setItem("d", "0");
            newDateRange();
        }
        // if( localStorage.getItem("pbs") <= localStorage.getItem("pbe") ){
        // hideOnClickOutside();
        // setOpen(false);
        // newDateRange();
        // }
    }

    async function setDate(item) {
        localStorage.setItem("pbs", format(item[0].startDate, "yyyy-MM-dd"));
        localStorage.setItem("pbe", format(item[0].endDate, "yyyy-MM-dd"));
        localStorage.setItem("d", "1");
        setRange1(item);
        setOpen(false);
        newDateRange();
    }


    const getSortedServicesData = (services_data) => {
        if ("service_data" in services_data) {
            services_data = services_data.service_data;
        }
        const sort = Object.values(services_data).sort((a, b) => b - a);
        const keys = Object.keys(services_data);
        const sortedData = {};
        sort.forEach((val) => {
            keys.forEach((el) => {
                if (services_data[el] === val) {
                    sortedData[el] = val;
                }
            });
        });
        return sortedData;
    }


    const getDateBreakupHtml = (sortedServiceData) => {
        console.log('sortedServiceData', sortedServiceData);
        let html = [];
        let uniqueKey = 0;
        Object.keys(sortedServiceData).forEach((keys) => {
            let pointName = keys[0].toUpperCase() + keys.slice(1);
            let image = '';
            if (keys === "bonus") {
                image = require("./../images/" + keys + ".svg").default;
            } else {
                image = require("./../images/" + keys + ".png").default;
            }
            if (keys === "bonus") {
                pointName = "Bonus";
            } else if (keys === "aeps") {
                pointName = keys.toUpperCase();
            } else if (keys === "micro_atm") {
                pointName = "Micro ATM";
            } else if (keys === "dmt") {
                pointName = keys.toUpperCase();
            } else if (keys === "ppi") {
                pointName = "PPI Loading";
                // keys = "dmt";
            } else if (keys === "war") {
                pointName = "War Points";
            } else if (keys === "recharge") {
                pointName = "Mobile/DTH Recharge";
            } else if (keys === "dhanakHub") {
                pointName = "Dhanak Device Hub";
            } else if (keys === "dhanakRefurb") {
                return;
                pointName = "Dhanak Refurb";
            } else if (keys === "impact_bonus") {
                return;
            } else if (keys === "irctc") {
                pointName = "Irctc";
            } else if (keys === "pan_card") {
                pointName = "Pan Card";
            } else if (keys === "daily_invest") {
                pointName = "Daily Reserve";
            } else if (keys === "topup") {
                pointName = "Online Topup";
            } else if (keys === "gatway") {
                pointName = "Payments";
            } else if (keys === "gatway_portal") {
                pointName = "Partner Portal";
            } else if (keys === "membership") {
                return;
                pointName = "Membership";
            } else if (keys === "utility") {
                pointName = "Bill Payment";
            } else if (keys === "utility_portal") {
                pointName = "Bill Payment ( Partner Portal )";
            } else if (keys === "cash_rotation_bonus") {
                pointName = "Cash Rotation Bonus";
            } else if (keys === "saarthi_bonus") {
                if(!sortedServiceData[keys]>0){
                    return;
                }
                pointName = "Saarthi Bonus";
            }

            html.push(<li key={uniqueKey}>
                <div className="item item-imp">
                    <img src={image} alt={`${keys} image`} className="image" />
                    <div className="in">
                        <div className="point-name">{pointName}</div>
                        <span className="text-muted"><img
                            style={{ backgroundColor: "#fff", borderRadius: "50%" }}
                            alt="point image" src={require("./../images/pay1-points-img.svg").default} className="img-fluid" />{sortedServiceData[keys]}</span>
                    </div>
                </div>
            </li>);

            uniqueKey++;

        });
        return html;
    }


    //Final Home Page
    //ref
    let RankModalRef = useRef(null);
    let TotalPointsModalRef = useRef(null);
    let DailyPointsModalRef = useRef(null);
    let RetailerAstraModalRef = useRef(null);
    let SaleAstraModalRef = useRef(null);
    let ServiceAstraModalRef = useRef(null);
    let CongratulationModalRef = useRef(null);


    // style using hook
    let [backgroundImageStyle, setBackgroundImageStyle] = useState({
        backgroundImage: `url(${backgroundImage})`,
    });

    let [backgroundImgStyle, setBackgroundImgStyle] = useState({
        backgroundImage: ` url(${retailerAstraImg}) , url(${saleAstraImg}), url(${serviceAstraImg}), url(${backgroundImg})  `,
        // backgroundSize: "50% 50%, 50% 50%,50% 50%,100% 100%",
        backgroundRepeat: "no-repeat,no-repeat,no-repeat repeat-y"
    });

    // let [saleAstraImgStyle, setSaleAstraImgStyleStyle] = useState(
    //     <img src={require("../images/Astra/SaleAstra/Se0.png").default} alt="alt" className='pos-abs' width="100%" paddingLeft="10%"/>
    // );
    // let [retailerAstraImgStyle, setRetailerAstraImgStyleStyle] = useState(
    //     <img src={require("../images/Astra/RetailerAstra/R0.png").default} alt="alt" className='pos-abs' width="100%" paddingLeft="10%"/>
    // );
    // let [serviceAstraImgStyle, setServiceAstraImgStyleStyle] = useState(
    //     <img src={require("../images/Astra/ServiceAstra/S0.png").default} alt="alt" className='pos-abs' width="100%" paddingLeft="10%"/>
    // );

    let [myRankTopBarStyle, setMyRankTopBarStyle] = useState({
        backgroundImage: `url(${myRankBGImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%"
    });

    let [leaderboardStyle, setLeaderboardStyle] = useState({
        color: "#fff"
    });

    const [leaderboardComponent, setLeaderboardComponent] = useState(<MyRank btnRef={RankModalRef} />);
    // custom function
    const OpenRankModal = () => {
        RankModalRef.current.click();
    }

    const OpenTotalPointsModal = () => {
        TotalPointsModalRef.current.click();
    }

    const OpenDailyPointsModal = () => {
        DailyPointsModalRef.current.click();
        const dateDisplayWrapper = refOne.current.querySelector(".rdrDateDisplayWrapper");
        // Applying the CSS style
        if (dateDisplayWrapper) {
            dateDisplayWrapper.style.display = "none";
        }
    }


    const OpenRetailerAstraModal = () => {
        RetailerAstraModalRef.current.click();
    }

    const OpenSaleAstraModal = () => {
        SaleAstraModalRef.current.click();
    }

    const OpenServiceAstraModal = () => {
        ServiceAstraModalRef.current.click();
    }

    function OpenCongratulationModal() {
        setTimeout(() => CongratulationModalRef.current.click(), 1000);
    }

    async function closeCongratulationPopup() {
        let val = localStorage.getItem("ami");
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ dist_user_id: user_id, val: pointsBreakup.typeCode }),

        };
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'update-dist-animation-status', requestOptions);
        const data = await response.json();
    }

    const loadLeaderboardComponent = (isRankComponent) => {
        const style = {
            "bg": {
                backgroundImage: `url(${myRankBGImage})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                color: "#000"
            },
            "color": { color: "#fff" }
        };
        if (isRankComponent) {
            setLeaderboardComponent(<MyRank btnRef={RankModalRef} />);
            setMyRankTopBarStyle(style.bg);
            setLeaderboardStyle(style.color);
        } else {
            setLeaderboardComponent(<BKBLeaderboard />);
            setMyRankTopBarStyle(style.color);
            setLeaderboardStyle(style.bg);
        }
    }

    const [selectedButton, setSelectedButton] = useState('saleAstra');
    const scrollableRef = useRef(null);
    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
    };

    const scrollToEnd = () => {
        if (scrollableRef.current) {
            scrollableRef.current.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        }
    };

    const searchAndReplace = (str) => {
        return str.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    }


    return (
        <>
            <Helmet link={
                [{ "rel": "stylesheet", "href": 'css/HomePage.css' }]
            } />
            <div className="row no-gutters">
                {loader === "true" && (
                    <div className="application bg-greyis" id="loading">
                    </div>
                )
                }
                {loader === 'false' && (
                    <div className="bg-bkb-img application sc" >

                        <div className="backAndProfile">
                            <div className="goBack"><a onClick={() => history.goBack()}>
                                <img
                                    alt=""
                                    src={require("./../images/Normal-dist/Arrow_back.png").default}
                                    className="img-fluid backIcon"
                                    style={{ visibility: "hidden" }}
                                />
                            </a></div>
                            <div className="goBack" onClick={getPointsBreakup}><a>
                                {showing}
                            </a></div>
                            {/* <div style={{color: "white",fontStyle: "inherit",right: "50%",position: "absolute",marginTop: "10px", display : "inline-block"}}>Detailed Insight</div>     */}
                            <div className='profile'>

                                {pointsBreakup.dist_profile_pic !== '' && (
                                    <img
                                        style={{ width: "75%", height: "100%", borderRadius: "50%", padding: "5%" }}
                                        alt=""
                                        src={pointsBreakup.dist_profile_pic}
                                        className="img-fluid profile_image"
                                    />
                                )
                                }
                            </div>
                        </div>

                        {/* <div className="backAndProfile">
                    <div className="backAndProfileInner">Child div with full width</div>
                </div> */}
                        <div className="bg-bkb-img sc page-1" style={backgroundImgStyle}>
                            <div className="astra-section">
                                <div id="carouselExampleControls" className="carousel slide carousel-size" data-touch="true" data-ride="carousel" data-interval="true">
                                    <ol className="carousel-indicators">
                                        <li ref={slide1} key="si1" data-target="#carouselExampleControls" data-slide-to="0" className="active keysA1" ></li>
                                        <li ref={slide2} key="si2" data-target="#carouselExampleControls" data-slide-to="1" ></li>
                                    </ol>
                                    <div className="carousel-inner" role="listbox">
                                        {/* 1st slide */}
                                        <div key="s1" className="active carousel-item bkb">
                                            <div className="align-items-center justify-content-center min-vh-100 custom_bg_size" style={carausolBackgroundImgStyle} >
                                                <div className="pos-relative">
                                                    {retailerTargetDisplay}
                                                    {serviceTargetDisplay}
                                                </div>
                                                {saleTargetDisplay}
                                            </div>
                                        </div>
                                        {slideMarker === '1' && (
                                            <Link to={{
                                                pathname: "/region-home"
                                            }} className="carousel-item bkb">
                                                <div
                                                    className="align-items-center justify-content-center slide_3"
                                                    style={{
                                                        backgroundImage: `url(${require("../images/Impact_player_screen/Onboarding_screen/two_days_back.png")
                                                            .default
                                                            })`,
                                                        backgroundSize: "100% 100%",
                                                    }}
                                                >
                                                    <div className="battle_no text-white text-center" style={{ paddingTop: "6vh" }}>BATTLE NO. {warData.battle_no} </div>
                                                    <div className='teams'>
                                                        <div className="team_1 text-white text-center">
                                                            <span>{warData.kd1_name}</span>
                                                        </div>
                                                        <div style={{ width: '20%' }}></div>
                                                        <div className="team_2 text-white text-center"><span>{warData.kd2_name}</span> </div>
                                                    </div>
                                                    <div className="timers text-white text-center">
                                                        <span>{timerComponents2}</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        )}
                                        {secondSlide}
                                    </div>
                                </div>
                            </div>
                            {/* <div className='pos-relative'>
                        {retailerTargetDisplay}
                        {serviceTargetDisplay}
                    </div>
                    {saleTargetDisplay} */}
                            <div className='parent-sec'>
                                <div className='points-section'>
                                    <div className='points-div'>
                                        <div className='pay1_points' onClick={OpenTotalPointsModal}>
                                            <img src={require("./../images/BKB-Elements/p1.svg").default} alt="alt" /> <span>{pointsBreakup.total_points}</span>
                                        </div>
                                        <div className='pay1_points' onClick={OpenDailyPointsModal}>
                                            <img src={require("./../images/BKB-Elements/p1.svg").default} alt="alt" /> <span>{dailyPts}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='target-info'>
                                {pointsBreakup.dist_who_completed_target.replace(/Brahmasta/g, "Brahmastra")}
                            </div>
                            <div className='parent'>
                                <div className="rank-icon" onClick={OpenRankModal}>
                                    <img src={require("./../images/BKB-Elements/Rank.png").default} alt="alt" />
                                    <div className='text-white rankPoints'>{pointsBreakup.rank}</div>
                                    <i className='text-white rankText'>Rank</i>
                                </div>
                                <div className="ptsJorneyCont">
                                    <div className="points-journey-bar"
                                    onClick={() => handleMildstoneClick('10L')}>
                                        <div className="bar-sect bar-sect-1">
                                            <div className="left-side-bar left-side-bar-first" style={{ 'width': `${milestone.a}` }}>&nbsp;</div>
                                            <div className="right-side-bar" style={{ 'width': `${milestone.b}` }}>&nbsp;</div>
                                            <div className="side-bar-icon">
                                                <img src={milestone.l1} />
                                            </div>
                                            <div className="side-bottom-bar-icon">
                                                <img src={require("./../images/3000-gift-voucher.svg").default} className="img-fluid" />
                                            </div>
                                        </div>
                                        <div className="bar-sect bar-sect-2">
                                            <div className="left-side-bar" style={{ 'width': `${milestone.c}` }}>&nbsp;</div>
                                            <div className="right-side-bar" style={{ 'width': `${milestone.d}` }}>&nbsp;</div>
                                            <div className="side-bar-icon">
                                                {/* <img src={require("./../images/5l-act.svg").default}/> */}
                                                <img src={milestone.l3} />
                                            </div>
                                            <div className="side-bottom-bar-icon">
                                                <img src={require("./../images/10000-gift-voucher.svg").default} className="img-fluid" />
                                            </div>
                                        </div>
                                        <div className="bar-sect bar-sect-3">
                                            <div className="left-side-bar" style={{ 'width': `${milestone.e}` }}>&nbsp;</div>
                                            <div className="right-side-bar" style={{ 'width': `${milestone.f}` }}>&nbsp;</div>
                                            <div className="side-bar-icon">
                                                <img src={milestone.l10}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleMildstoneClick('10L')}
                                                />
                                            </div>
                                            <div className="side-bottom-bar-icon"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleMildstoneClick('10L')}
                                            >
                                                <img src={require("./../images/5gm-gold-coin.svg").default} className="img-fluid" />
                                            </div>
                                        </div>
                                        <div className="bar-sect bar-sect-4">
                                            <div className="left-side-bar" style={{ 'width': `${milestone.g}` }}>&nbsp;</div>
                                            <div className="right-side-bar" style={{ 'width': `${milestone.h}` }}>&nbsp;</div>
                                            <div className="side-bar-icon">
                                                <img src={milestone.l25}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleMildstoneClick('25L')}
                                                />
                                            </div>
                                            <div className="side-bottom-bar-icon"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleMildstoneClick('25L')}
                                            >
                                                <img src={require("./../images/10gm-gold-coin.svg").default} className="img-fluid" />
                                            </div>
                                        </div>
                                        <div className="bar-sect bar-sect-5">
                                            <div className="left-side-bar" style={{ 'width': `${milestone.i}` }}>&nbsp;</div>
                                            <div className="right-side-bar" style={{ 'width': `${milestone.j}` }}>&nbsp;</div>
                                            <div className="side-bar-right-icon">
                                                <img src={require("./../images/bkb3-gifts.png").default} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className='view-insights' onClick={scrollToEnd}>Business Pe Pakad &nbsp;<img style={{ width: "20px" }} src={require("./../images/Normal-dist/Business_pe_pakad.gif").default} /></div> */}
                        </div>

                        {/* <div ref={scrollableRef} className='page-2 bg-bkb-img sc2 bg-brown' >
                            <div className='page2-heading'>Business Pe Pakad</div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="narDiv">
                                        <ul className="list-inline d-flex justify-content-center">
                                            <li>

                                                <div onClick={() => handleButtonClick('saleAstra')} className='astraBtn'>
                                                    {
                                                        selectedButton === 'saleAstra' ? <img className='width-100-px' src={require("./../images/Normal-dist/saleastra_bg.png").default} /> : <img className='width-100-px' src={require("./../images/Normal-dist/saleastra_btn.png").default} />
                                                    }

                                                </div>
                                            </li>
                                            <li>
                                                <div onClick={() => handleButtonClick('retailerAstra')} className='astraBtn'>
                                                    {
                                                        selectedButton === 'retailerAstra' ? <img className='width-100-px' src={require("./../images/Normal-dist/retailer_astra_btn.png").default} /> : <img className='width-100-px' src={require("./../images/Normal-dist/retailer_astra_btn_1.png").default} />
                                                    }
                                                </div>
                                            </li>
                                            <li>
                                                <div onClick={() => handleButtonClick('serviceAstra')} className='astraBtn'>
                                                    {
                                                        selectedButton === 'serviceAstra' ? <img className='width-100-px' src={require("./../images/Normal-dist/service_astra_btn.png").default} /> : <img className='width-100-px' src={require("./../images/Normal-dist/service_astra.png").default} />
                                                    }
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                           
                            <div className={selectedButton === 'saleAstra' ? 'card saleAstraDiv displayBlockAstra' : 'card saleAstraDiv displayNoneAstra'}>
                                <div className='card-body' style={{ paddingTop: "5px" }}>
                                    <div className=''>
                                        <div className='header-part'>
                                            <div className='header-part-1'>
                                                <p className='text-center' style={{ margin: "0px", color: "white", fontSize: "12px", fontWeight: "500" }}>Sale Astra</p>
                                                <SemiProgressBar initialValue={targetsData.sale.percentage} isTargetCompleted={targetsData.sale.completed_status} astraNum={1} targests_data={targetsData} />
                                                <div className='target-area'>
                                                    <div className={'astra-target' + targetsData.sale.completed_status + "sa"}>Target : &nbsp;

                                                        {targetsData.sale.completed_status === false ? "₹ " + targetsData.sale.total_taget : " completed"}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='header-part-2'>
                                                <p className='h-part-2-content' style={{ color: "white", marginTop: "10px" }}>Highest Record : {targetsData.sale.highest_record !== "" ? targetsData.sale.highest_record : "NA"}</p>
                                                
                                                <p className='h-part-2-content' style={{ color: "white" }}>
                                                    (Recharge, Utility, PG, DMT, MATM, Aeps, IRCTC, Flight, Cashdrop, Pan Card, Dhanak will be considered.)
                                                </p>
                                            </div>
                                        </div>
                                        <hr style={{ height: "2px", marginBottom: "0.4rem", backgroundColor: "#dee0e0" }} className='mgt2' />
                                        <div className='table-area'>
                                            <TableData data={targetsData} tableKeyName={'sale'} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                       
                            <div className={selectedButton === 'retailerAstra' ? 'card retailerAstraDiv displayBlockAstra' : 'card retailerAstraDiv displayNoneAstra'}>
                                <div className='card-body' style={{ paddingTop: "5px" }}>
                                    <div className=''>
                                        <div className='header-part'>
                                            <div className='header-part-1'>
                                                <p className='text-center' style={{ margin: "0px", color: "white", fontSize: "12px", fontWeight: "500" }}>Retailer Astra</p>
                                                <SemiProgressBar initialValue={targetsData.retailer.percentage} isTargetCompleted={targetsData.retailer.completed_status} astraNum={2} targests_data={targetsData} />
                                                <div className='target-area'>
                                                    <div className={'astra-target' + targetsData.retailer.completed_status + "re"}>Target : {targetsData.retailer.completed_status === false ? targetsData.retailer.total_target : "completed"}</div>
                                                </div>
                                            </div>
                                            <div className='header-part-2'>
                                                <p className='h-part-2-content' style={{ color: "white", marginTop: "45px" }}>
                                                    (Recharge, DMT, IRCTC,MATM,Aeps,Cashdrop,PG,Dhanak, Flight will be considered.)
                                                </p>
                                            </div>
                                        </div>
                                        <hr style={{ height: "2px", marginBottom: "0.4rem", backgroundColor: "#dee0e0" }} />
                                        <div className='table-area'>
                                            <TableData data={targetsData} tableKeyName={'retailer'} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                     
                            <div className={selectedButton === 'serviceAstra' ? 'card serviceAstraDiv displayBlockAstra' : 'card serviceAstraDiv displayNoneAstra'}>
                                <div className='card-body' style={{ paddingTop: "5px" }}>
                                    <div className=''>
                                        <div className='header-part'>
                                            <div className='header-part-1'>
                                                <p className='text-center' style={{ margin: "0px", color: "white", fontSize: "12px", fontWeight: "500" }}>Service Astra</p>
                                                <SemiProgressBar initialValue={targetsData.service.percentage} isTargetCompleted={targetsData.service.completed_status} astraNum={3} targests_data={targetsData} />
                                                <div className='target-area'>
                                                    <div className={'astra-target' + targetsData.service.completed_status + "se"}>Target : &nbsp;
                                                        {targetsData.service.completed_status === false ? serviceTarget : " completed"}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='header-part-2'>
                                                <div className='completed-service' style={{ color: "white" }}>
                                                    <div style={{ marginBottom: "5px", fontSize: "0.9rem", fontWeight: "500" }}>Completed Services - ({targetsData.service.completed_target + '/' + serviceTarget})</div>
                                                    <span style={{ fontSize: '0.7rem', fontWeight: 500 }}>
                                                        {pointsBreakup.completedServices.map((service, index) => (
                                                            // <img key={index} src={require("./../images/"+service+".png").default}/>
                                                            <React.Fragment key={index}>
                                                                {searchAndReplace(service)}
                                                                {index !== pointsBreakup.completedServices.length - 1 && ", "}
                                                            </React.Fragment>
                                                        ))}
                                                    </span>
                                                    <div style={{ marginTop: "5px", marginBottom: "5px", color: "#FDAF06", fontSize: "0.9rem", fontWeight: "500" }}>Pending Services</div>
                                                    <span style={{ fontSize: '0.7rem', fontWeight: 500 }}>
                                                        {pointsBreakup.pendigServicesNames.map((service, index) => (
                                                            <React.Fragment key={index}>
                                                                {searchAndReplace(service)}
                                                                {index !== pointsBreakup.pendigServicesNames.length - 1 && ", "}
                                                            </React.Fragment>
                                                            // <img key={index} src={require("./../images/"+service+".png").default}/>
                                                        ))}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <hr style={{ height: "2px", marginBottom: "0.4rem", backgroundColor: "#dee0e0" }} />
                                        <div className='table-area'>
                                            <TableData data={targetsData} tableKeyName={'service'} />
                                        </div>
                                    </div>
                                </div>
                            </div>
        
                        </div> */}
                    </div>
                )
                }
                {loader === 'error' && (
                    <Redirect to='/' />
                )
                }
                <div className="bg"></div>
            </div>

            {/* show error msg popup */}
            <a data-toggle="modal" ref={inputRef} data-target="#bottom_modal"></a>
            <div className="modal bottom fade" id="bottom_modal" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-0 px-26 text-center d-block" style={{ height: `50px` }}>
                            <h5 className="modal-title">Alert</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ opacity: `1`, position: `relative`, top: `-20px` }}>
                                <img src={require("./../images/close.png").default} alt="close" className="img-fluid" />
                            </button>
                        </div>
                        <div className="modal-body px-34">
                            <p className="mb-0 text-black">{desc}</p>
                            <div className="row justify-content-center my-3"></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Impact Player modal */}
            <div className="modal bottom fade" id="ip_rank_modal" tabIndex="-1" role="dialog" aria-labelledby="ip_rank_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body impact-player_ranking">
                            {/* <ImpactPlayerLeaderboard></ImpactPlayerLeaderboard> */}
                            <div className="impact-player-ranking-card">
                                <ImpactPlayerLeaderboard />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* Rank modal */}
            <a data-toggle="modal" ref={RankModalRef} data-target="#rank_modal"></a>
            <div className="modal bottom fade" id="rank_modal" tabIndex="-1" role="dialog" aria-labelledby="rank_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header rankModalHeader border-0 px-26 d-block">
                            <div className='rank-modal-header'>
                                <div className='my-rank'>
                                    <button className='my_rank_text text-center' style={myRankTopBarStyle} onClick={() => loadLeaderboardComponent(true)}>
                                        MY RANK
                                    </button>
                                </div>
                                <div className='leaderboard'>
                                    <button className='leaderboard_text text-center' style={leaderboardStyle} onClick={() => loadLeaderboardComponent(false)}>
                                        LEADERBOARD
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body px-34 totalPointsModalBody">
                            {
                                leaderboardComponent
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* Total Points modal */}
            <a data-toggle="modal" ref={TotalPointsModalRef} data-target="#total_points_modal"></a>
            <div className="modal bottom fade" id="total_points_modal" tabIndex="-1" role="dialog" aria-labelledby="total_points_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header totalPointsModalHeader border-0 px-26 d-block">
                            <div className="dropdown pl-1" style={{ display: "inline-block", backgroundColor: "#33302E", width: "60%" }}>
                                <div
                                    className="inputBox"
                                    onClick={() => setOpen(open => !open)}
                                >
                                    <i className="fa fa-calendar calendarIcon"></i>
                                    <span className="date-str-cont">{`${format(range[0].startDate, "yyyy-MM-dd")} to ${format(range[0].endDate, "yyyy-MM-dd")}`}</span></div>

                                <div ref={refOne} style={{
                                    zIndex: 10000, position: 'fixed',
                                    display: 'inline-block',
                                    top: '50%',
                                    left: '50%',
                                    margin: 'auto',
                                    transform: `translate(-50%, -50%)`
                                }}>
                                    {open &&
                                        <DateRange
                                            onChange={item => setRange2([item.selection])}
                                            // onChange={item => setRange([item.selection])}
                                            // disabledDate={combine(allowedMaxDays(7))}
                                            minDate={miDate}
                                            maxDate={maDate}
                                            // editableDateInputs={true}
                                            moveRangeOnFirstSelection={false}
                                            ranges={range}
                                            months={1}
                                            direction="horizontal"
                                            className="calendarElement"
                                        />
                                    }
                                </div>
                            </div>
                            <div className="right w-30" style={{ float: "right", color: "#fff", fontWeight: "500" }}>
                                <img style={{ backgroundColor: "#fff", borderRadius: "50%" }} alt="point image" src={require("./../images/pay1-points-img.svg").default} className="img-fluid" /> {" " + dateRangeBreakup.month_total}
                            </div>
                        </div>
                        <div className="modal-body px-34 totalPointsModalBody">
                            <ul id="bg-greye" className="listview image-listview points-list">
                                {sortedDateRangeBreakupHtmlData}

                            </ul>
                        </div>
                    </div>
                </div>
            </div>


            {/* Daily Points modal */}
            <a data-toggle="modal" ref={DailyPointsModalRef} data-target="#daily_points_modal"></a>
            <div className="modal bottom fade" id="daily_points_modal" tabIndex="-1" role="dialog" aria-labelledby="daily_points_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header totalPointsModalHeader border-0 px-26 d-block">
                            <div className="dropdown pl-1" style={{ display: "inline-block", backgroundColor: "#33302E", width: "38%" }}>
                                <div
                                    className="inputBox"
                                    onClick={() => setOpen(open => !open)}
                                >
                                    <i className="fa fa-calendar calendarIcon"></i>
                                    <span className="date-str-cont">{`${format(range1[0].startDate, "yyyy-MM-dd")}`}</span></div>

                                <div ref={refOne} style={{
                                    zIndex: 10000, position: 'fixed',
                                    display: 'inline-block',
                                    top: '50%',
                                    left: '50%',
                                    margin: 'auto',
                                    transform: `translate(-50%, -50%)`
                                }}>
                                    {open &&
                                        <DateRange
                                            onChange={item => setDate([item.selection])}
                                            // moveRangeOnFirstSelection={false}
                                            ranges={range1}
                                            months={1}
                                            direction="horizontal"
                                            className="calendarElement"
                                        />
                                    }
                                </div>
                            </div>
                            <div className="right w-30" style={{ float: "right", color: "#fff", fontWeight: "500" }}>
                                <img style={{ backgroundColor: "#fff", borderRadius: "50%" }} alt="point image" src={require("./../images/pay1-points-img.svg").default} className="img-fluid" /> {" " + dateBreakup.month_total}
                            </div>
                        </div>
                        <div className="modal-body px-34 totalPointsModalBody">
                            <ul id="bg-greye" className="listview image-listview points-list">
                                {sortedDateBreakupHtmlData}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Retailer Astra modal */}
            <a data-toggle="modal" ref={RetailerAstraModalRef} data-target="#retailer_astra_modal"></a>
            <div className="modal bottom fade" id="retailer_astra_modal" tabIndex="-1" role="dialog" aria-labelledby="retailer_astra_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content bg_image">
                        <div className="modal-header astraPopupHeader border-0 px-26 d-block">
                            <div className='targetPopupTitle'>
                                <i>RETAILER ASTRA</i>
                            </div>
                        </div>
                        <div className="modal-body px-34">

                            <div style={{ height: "100px" }}></div>
                            <div className='target_content'>
                                <span className='text-underline text-white target_text'>TARGET :</span>
                                <div className='clearfix'></div>
                                <div style={{ width: "20em" }}>
                                    <span className='text-white float-right'>{pointsBreakup.targets_data.retailer.completed_target}</span>
                                </div>
                                <div className="progress custom_progress">
                                    <div className="progress-bar custom_progress_css" role="progressbar" style={{ width: pointsBreakup.targets_data.retailer.percentage + "%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <div className='target_text text-underline text-white' style={{ marginTop: "20px" }}>
                                    STEP TO UNLOCK :
                                </div>
                                <div className='target_steps text-white'>
                                    <div className='step_1'>
                                        <span className='step'>STEP 1 : </span>
                                        <span className='step_content'>Do transaction with the given below retailers.</span>
                                    </div>
                                    <div className='step_2'>
                                        <span className='step'>TARGET : </span>
                                        <span className='step_content'>{pointsBreakup.targets_data.retailer.total_target} Retailers(min. txn of 100 each)</span>
                                    </div>
                                </div>
                                <div className='notice text-white'>{textData}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Sale Astra modal */}
            <a data-toggle="modal" ref={SaleAstraModalRef} data-target="#sale_astra_modal"></a>
            <div className="modal bottom fade" id="sale_astra_modal" tabIndex="-1" role="dialog" aria-labelledby="sale_astra_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content bg_image_sale">
                        <div className="modal-header astraPopupHeader border-0 px-26 d-block">
                            <div className='targetPopupTitle'>
                                <i>SALE ASTRA</i>
                            </div>
                        </div>
                        <div className="modal-body px-34">

                            <div style={{ height: "75px" }}></div>
                            <div className='target_content'>
                                <span className='text-underline text-white target_text'>TARGET :</span>
                                <div className='clearfix'></div>
                                <div style={{ width: "20em" }}>
                                    <span className='text-white float-right'>{pointsBreakup.targets_data.sale.completed_target}</span>
                                </div>
                                <div className="progress custom_progress">
                                    <div className="progress-bar custom_progress_css" role="progressbar" style={{ width: pointsBreakup.targets_data.sale.percentage + "%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <div className='target_text text-underline text-white' style={{ marginTop: "20px" }}>
                                    STEP TO UNLOCK :
                                </div>
                                <div className='target_steps text-white'>
                                    <div className='step_1'>
                                        <span className='step'>STEP 1 :</span>
                                        <span className='step_content'> Achieve your highest sale target given below.</span>
                                    </div>
                                    <div className='step_2'>
                                        <span className='step'>TARGET :</span>
                                        <span className='step_content'> <span>&#8377;</span> {pointsBreakup.targets_data.sale.total_taget}.</span>
                                    </div>
                                </div>
                                <div className='notice text-white'>{textData}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Service Astra modal */}
            <a data-toggle="modal" ref={ServiceAstraModalRef} data-target="#service_astra_modal"></a>
            <div className="modal bottom fade" id="service_astra_modal" tabIndex="-1" role="dialog" aria-labelledby="service_astra_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content bg_image_service">
                        <div className="modal-header astraPopupHeader border-0 px-26 d-block">
                            <div className='targetPopupTitle'>
                                <i>SERVICE ASTRA</i>
                            </div>
                        </div>
                        <div className="modal-body px-34">
                            <div style={{ height: "120px" }}></div>
                            <div className='target_content'>
                                <span className='text-underline text-white target_text'>TARGET :</span>
                                <div className='clearfix'></div>
                                <div style={{ width: "20em" }}>
                                    <span className='text-white float-right'>{pointsBreakup.targets_data.service.completed_target}</span>
                                </div>
                                <div className="progress custom_progress">
                                    <div className="progress-bar custom_progress_css" role="progressbar" style={{ width: pointsBreakup.targets_data.service.percentage + "%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <div className='target_text text-underline text-white' style={{ marginTop: "20px" }}>
                                    STEP TO UNLOCK :
                                </div>
                                <div className='target_steps text-white'>
                                    <div className='step_1'>
                                        <span className='step'>STEP 1 :</span>
                                        <span className='step_content'> Do transaction using {pointsBreakup.targets_data.service.total_taget < 5 ? pointsBreakup.targets_data.service.total_taget + 1 : pointsBreakup.targets_data.service.total_taget} services..</span>
                                    </div>
                                    {pendingServices}
                                </div>
                                <div className='notice text-white'>{textData}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Congratulation modal */}
            <a data-toggle="modal" ref={CongratulationModalRef} data-target="#congratulation_modal"></a>
            <div className="modal bottom fade" id="congratulation_modal" tabIndex="-1" role="dialog" aria-labelledby="congratulation_modal" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog" role="document">
                    <div className="modal-content bg_image_congrats">
                        <div className="modal-header astraPopupHeader border-0 px-26 d-block">
                            <h3 className='text-center mt-2' style={{ color: "#eba434" }}>
                                CONGRATULATIONS
                            </h3>
                            {congratulationPopupHeaderContent}
                        </div>
                        <div className="modal-body px-34">
                            <div className='target_image'>
                                {
                                    pointsBreakup.targets_data.all_target_completed_status === true
                                        ?
                                        <div className='target_completed text-center'>
                                            <img src={require("./../images/BKB-Elements/full_stone.png").default} />
                                        </div>
                                        :
                                        <div className='any_two_of_them text-center'>

                                            {
                                                srcUrl.image_one !== null && <div className='target_1'>
                                                    <img style={{ width: "100%" }} src={srcUrl.image_one} />
                                                </div>
                                            }
                                            {
                                                srcUrl.image_two !== null && <div className='target_2 ml-2'>
                                                    <img style={{ width: "100%" }} src={srcUrl.image_two} />
                                                </div>
                                            }
                                        </div>
                                }


                            </div>
                            {
                                pointsBreakup.targets_data.all_target_completed_status === false
                                && <div className='text-center text-white'>
                                    <span>
                                        {congratsFooterContent}
                                    </span>
                                </div>
                            }

                            <div className='okBtn text-center mt-2'>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ opacity: `1`, position: `relative`, float: `none` }} onClick={closeCongratulationPopup}>
                                    <img src={require("./../images/BKB-Elements/ok_button.png").default} />
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default HomePage;
